<!-- <shared-loader-general [loading]="loading"></shared-loader-general> -->
@if (loading) {
  <div class="mt-4 w-full space-y-3">
    <ngx-skeleton-loader count="1" [theme]="{height:'20px', 'border-radius':'8px'}"></ngx-skeleton-loader>
    <ngx-skeleton-loader count="3" [theme]="{height:'36px', 'border-radius':'8px'}"></ngx-skeleton-loader>
    <ngx-skeleton-loader count="1" [theme]="{height:'20px', 'border-radius':'8px'}"></ngx-skeleton-loader>
    <ngx-skeleton-loader count="4" [theme]="{height:'40px', 'border-radius':'8px'}"></ngx-skeleton-loader>
  </div>
} @else {
<div class="mt-4 w-full" [class.opacity-50]="loading">
  <!-- Variaciones -->
  @for (variation of variations; track variation) {
    <div class="mb-4 border border-gray-200 rounded-lg overflow-hidden">
      <div class="flex justify-between items-center p-3 bg-gray-50">
        <h3 class="text-base font-medium">
          {{ variation.name }}
          @if (variation.isRequired === true) {
            <span class="text-xs text-white bg-red-500 px-2 py-0.5 rounded-full ml-2">Requerido</span>
          }
        </h3>
      </div>
      <!-- Opciones de la variación en tarjetas -->
      <div class="flex flex-wrap gap-2 md:gap-3 p-3 border-t border-gray-200">
        @for (option of variation.options; track option) {
          <button
            type="button"
            class="cursor-pointer px-3 py-2 rounded-lg text-sm font-medium transition-colors border hover:shadow-sm"
            [ngClass]="selectedOptions[variation.variation_id] === option.variationOption_id ? 'border-orange-500 bg-orange-50 text-orange-700' : 'border-gray-200 bg-white text-gray-800'"
            (click)="selectedOptions[variation.variation_id] = option.variationOption_id; selectionChanged.emit()"
          >
            <div>{{ option.name }}</div>
            @if (option.priceAdjustment !== '0') {
              <div class="text-xs text-gray-600">+${{ option.priceAdjustment }}</div>
            }
          </button>
        }
      </div>
    </div>
  }

  <!-- Complementos -->
  @if(complements.length > 0 ){
  <div class="mb-4 w-full border border-gray-200 rounded-lg overflow-hidden">
    <div class="flex justify-between items-center p-3 bg-gray-50">
      <h3 class="text-base font-medium">Extras opcionales</h3>
    </div>

    <div class="space-y-2 md:space-y-3 p-3 border-t border-gray-200 max-h-60 overflow-y-auto">
      @for (complement of complements; track complement) {
        <div class="flex items-center p-3 border border-gray-200 rounded-lg hover:border-orange-400 transition-colors">
          <input
            type="checkbox"
            [id]="'complement-' + complement.PK_complement_id"
            class="h-4 w-4 text-orange-500 rounded border-gray-300 focus:ring-orange-400"
            [checked]="isComplementSelected(complement.PK_complement_id)"
            (change)="toggleComplement(complement.PK_complement_id)">
          <label [for]="'complement-' + complement.PK_complement_id" class="ml-3 block text-sm text-gray-900 flex-grow flex justify-between items-center">
            <span class="font-medium">{{ complement.name }}</span>
            <span class="text-xs text-gray-600">+${{ complement.price }}</span>
          </label>
        </div>
      }
    </div>
  </div>
  }

</div>
}
